import { createSlice } from "@reduxjs/toolkit";
import { topRatedNonprofitsAPI,topRatedFiltersAPI } from "../../../api/publicApi";
import { TopRatedNonprofitParamsProps } from "../../../utils/types";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
  filters:null
};

const topRatedNonprofitsSlice = createSlice({
  name: "topRatedNonprofits",
  initialState: data,
  reducers: {
    topRatedNonprofitsSlice(state) {
      state.isLoading = true;
    },
    topRatedNonprofitsSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    topRatedFiltersSliceSuccess(state, action) {
      state.isLoading = true;
      state.filters = action.payload;
      state.message = null;
    },
    topRatedNonprofitsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    topRatedNonprofitsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const topRatedNonprofitsHandler = (params:TopRatedNonprofitParamsProps) => async (dispatch: any) => {
  try {
    dispatch(topRatedNonprofitsAction.topRatedNonprofitsSlice());
    const response: any = await topRatedNonprofitsAPI(params);
    dispatch(topRatedNonprofitsAction.topRatedNonprofitsSliceSuccess(response));
  } catch (e: any) {
    dispatch(topRatedNonprofitsAction.topRatedNonprofitsSliceFailure(e?.response?.data?.message));
    dispatch(topRatedNonprofitsAction.topRatedNonprofitsSliceReset());
  }
};
export const topRatedFiltersHandler = () => async (dispatch: any) => {
  try {
    dispatch(topRatedNonprofitsAction.topRatedNonprofitsSlice());
    const response: any = await topRatedFiltersAPI();
    dispatch(topRatedNonprofitsAction.topRatedFiltersSliceSuccess(response));
  } catch (e: any) {
    dispatch(topRatedNonprofitsAction.topRatedNonprofitsSliceFailure(e?.response?.data?.message));
    dispatch(topRatedNonprofitsAction.topRatedNonprofitsSliceReset());
  }
};
export default topRatedNonprofitsSlice.reducer;
export const topRatedNonprofitsAction = topRatedNonprofitsSlice.actions;
